import { useEffect, useRef } from "react";

export default function useAbortSignal() {
  const controller = useRef(null);

  useEffect(() => {
    controller.current = new AbortController();

    return () => {
      controller.current = null;
    };
  }, []);

  return { signal: controller.current?.signal, controller };
}
